import { Redirect, Route } from "react-router-dom"
import useAuthStore from "../store/authStore"
import ControlledNavigation from "./Components/ControlledNavigation.jsx"
import ErrorBoundary from "../Components/ErrorBoundary"

function ProtectedRoute({ component: Component, ...restOfProps }) {
    const isAuthenticated = useAuthStore((state) => state.isAuthenticated)
    // Remove or modify the role check if needed
    const userRole = useAuthStore((state) => state.role)
  
    return (
      <Route
        {...restOfProps}
        render={(props) =>
          isAuthenticated ? (  // Removed role check or make it more flexible
            <ErrorBoundary>
              <ControlledNavigation component={Component} />
            </ErrorBoundary>
          ) : (
            <Redirect to="/admin/login" />
          )
        }
      />
    )
  }

export default ProtectedRoute
